// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"3d2850f4","141":"5a1aa24b","205":"766209f5","207":"33170d17","220":"83c93f99","224":"7e450f73","255":"3d20896a","279":"d8bc6adc","395":"c85a5ef0","859":"8a256a7d","890":"8d64a930","935":"521be76a","983":"2d0d750a"}[chunkId] + ".chunk.js";
};